<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <dara-header>{{ $t('tags') }}</dara-header>
      <table class="table">
        <tbody>
          <tr v-for="tag in tagsList" :key="tag.id">
            <td class="py-2 px-2">
              <dara-header size="sm">
                <dara-tag-link :id="tag.id">
                  #{{ tag.name }}
                </dara-tag-link>
              </dara-header>
              <small class="text-muted">
                {{ $t('articles') }}: {{ tag.articles.length }} | {{ $t('questions') }}: {{ tag.questions.length }}
              </small>
            </td>
          </tr>
        </tbody>
      </table>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetch" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { fetchTags } from '@/modules/tag/tag.service';

import DaraTagLink from '@/modules/tag/components/TagLink.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceTags',
  components: {
    DaraTagLink,
    DaraSingleContentLayout,
  },
  data() {
    return {
      tagsList: [],
      pagination: {
        page: 1,
        limit: 8,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.tagsList = [];
      fetchTags(this.pagination)
        .then(data => {
          this.tagsList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.tagsList = [];
        });
    },
  },
};
</script>
